import { DataTableColumn } from '../../Base/Components/DataTable/DataTable';
import { WorkplaceMedicalProceduresQuery } from '../../../graphql/graphql';
import ManagerInsuranceCompaniesCaseTypesInsuranceRow from '../Components/ManagerWrapper/InsuranceCompanies/ManagerInsuranceCompaniesCaseTypes/ManagerInsuranceCompaniesCaseTypesInsuranceRow';
import React from 'react';
import ManagerInsuranceCompaniesCaseTypeOpen from '../Components/ManagerWrapper/InsuranceCompanies/ManagerInsuranceCompaniesCaseType/ManagerInsuranceCompaniesCaseTypeOpen';
import ManagerInsuranceCompaniesCaseTypeDelete from '../Components/ManagerWrapper/InsuranceCompanies/ManagerInsuranceCompaniesCaseType/ManagerInsuranceCompaniesCaseTypeDelete';
import { QueryDataItem } from '../../../Interfaces/QueryDataItem';

export type WorkplaceMedicalProcedure = QueryDataItem<
	WorkplaceMedicalProceduresQuery['workplaceMedicalProcedures']
>;

export interface CaseTypesTable {
	refresh: () => void;
}

export const CaseTypesDefaultColumns: DataTableColumn<
	WorkplaceMedicalProcedure,
	CaseTypesTable
>[] = [
	{
		key: 'code',
		label: 'component.caseType.tableCode',
		bold: true,
		renderItem: (item: WorkplaceMedicalProcedure) => {
			return <span>{item?.medicalProcedure.code || ''}</span>;
		},
	},
	{
		key: 'name',
		label: 'component.caseType.tableName',
		renderItem: (item: WorkplaceMedicalProcedure) => {
			return <span>{item?.medicalProcedure.name || ''}</span>;
		},
	},
	{
		key: 'insuranceCompanies',
		label: 'component.caseType.tableInsuranceCompanies',
		renderItem: (
			item: WorkplaceMedicalProcedure,
			{ refresh }: CaseTypesTable,
		) => (
			<ManagerInsuranceCompaniesCaseTypesInsuranceRow
				item={item}
				reloadData={refresh}
			/>
		),
	},
	{
		key: 'openDetail',
		label: 'component.caseType.tableOpenDetail',
		renderItem: (item: WorkplaceMedicalProcedure) => (
			<ManagerInsuranceCompaniesCaseTypeOpen id={item.id} />
		),
	},
	{
		key: 'delete',
		label: 'component.caseType.tableDelete',
		renderItem: (
			item: WorkplaceMedicalProcedure,
			{ refresh }: CaseTypesTable,
		) => (
			<ManagerInsuranceCompaniesCaseTypeDelete
				id={item.id}
				reloadData={refresh}
			/>
		),
	},
];
